import React from 'react';

import JiraProjects from '../../images/jira.svg';

export const JiraProjectsLogo = () => {
  return <img height="18" src={JiraProjects} alt="Jira Projects logo" />;
};
